import { c as _c } from "react/compiler-runtime";
import { Box, Button, Dialog, IconButton, Stack, Typography } from '@mui/material';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
type AlertType = 'error' | 'warning' | 'success';
interface AlertDialogProps {
  open: boolean;
  setOpen?: (e: boolean) => void;
  title?: string;
  loading?: boolean;
  confirmText?: string;
  declineText?: string;
  type?: AlertType;
  description?: string;
  onConfirm?: () => void;
  onDecline?: () => void;
}
export default function AlertDialog(props) {
  const $ = _c(50);
  const {
    t
  } = useTranslation();
  const {
    title,
    description,
    open,
    loading: t0,
    type,
    confirmText: t1,
    declineText: t2,
    setOpen: t3,
    onConfirm,
    onDecline
  } = props;
  const loading = t0 === undefined ? false : t0;
  let t4;
  if ($[0] !== t || $[1] !== t1) {
    t4 = t1 === undefined ? t("styra.action.confirm") : t1;
    $[0] = t;
    $[1] = t1;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const confirmTitle = t4;
  let t5;
  if ($[3] !== t || $[4] !== t2) {
    t5 = t2 === undefined ? t("styra.action.cancel") : t2;
    $[3] = t;
    $[4] = t2;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const declineTitle = t5;
  const setOpen = t3 === undefined ? _temp : t3;
  let t6;
  if ($[6] !== setOpen) {
    t6 = () => setOpen(false);
    $[6] = setOpen;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      paper: {
        sx: {
          borderRadius: 3
        }
      }
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      alignItems: "center",
      justifyItems: "center",
      maxWidth: "450px",
      minWidth: "350px",
      position: "relative",
      padding: 3
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      alignItems: "center"
    };
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== type) {
    t10 = colors(type);
    $[11] = type;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10.main) {
    t11 = {
      justifyContent: "center",
      alignItems: "center",
      width: 36,
      height: 36,
      borderRadius: 999,
      border: "solid 1px",
      color: t10.main,
      mb: 1
    };
    $[13] = t10.main;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <PriorityHighRoundedIcon />;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t11) {
    t13 = <Stack sx={t11}>{t12}</Stack>;
    $[16] = t11;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== title) {
    t14 = title && <Typography component="p" variant="h6">{title}</Typography>;
    $[18] = title;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== description) {
    t15 = description && <Box>{description}</Box>;
    $[20] = description;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t13 || $[23] !== t14 || $[24] !== t15) {
    t16 = <Stack sx={t9}>{t13}{t14}{t15}</Stack>;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== confirmTitle || $[27] !== declineTitle || $[28] !== loading || $[29] !== onConfirm || $[30] !== onDecline || $[31] !== type) {
    t17 = onConfirm || onDecline ? <Stack spacing={2} direction="row" sx={{
      width: "100%"
    }}>{onDecline && <Button disabled={loading} fullWidth={true} color="inherit" sx={{
        bgcolor: "neutral.light",
        borderRadius: 2
      }} variant="contained" onClick={onDecline} size="large">{declineTitle}</Button>}{onConfirm && <Button loading={loading} fullWidth={true} color={colors(type).type} variant="contained" onClick={onConfirm} sx={{
        borderRadius: 2
      }} size="large">{confirmTitle}</Button>}</Stack> : null;
    $[26] = confirmTitle;
    $[27] = declineTitle;
    $[28] = loading;
    $[29] = onConfirm;
    $[30] = onDecline;
    $[31] = type;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t16 || $[34] !== t17) {
    t18 = <Stack spacing={4} sx={t8}>{t16}{t17}</Stack>;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== type) {
    t19 = colors(type);
    $[36] = type;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== setOpen) {
    t20 = e => {
      e.stopPropagation();
      setOpen(false);
    };
    $[38] = setOpen;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  let t22;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      position: "absolute",
      top: 3,
      right: 3,
      fontSize: 20,
      color: "rgba(0, 0, 0, 0.4)",
      "&:hover": {
        color: "inherit"
      }
    };
    t22 = <CloseIcon fontSize="inherit" color="inherit" />;
    $[40] = t21;
    $[41] = t22;
  } else {
    t21 = $[40];
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t19.type || $[43] !== t20) {
    t23 = <IconButton color={t19.type} size="small" onClick={t20} sx={t21}>{t22}</IconButton>;
    $[42] = t19.type;
    $[43] = t20;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== open || $[46] !== t18 || $[47] !== t23 || $[48] !== t6) {
    t24 = <Dialog open={open} onClose={t6} aria-labelledby="alert-dialog" aria-describedby="alert dialog" slotProps={t7}>{t18}{t23}</Dialog>;
    $[45] = open;
    $[46] = t18;
    $[47] = t23;
    $[48] = t6;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  return t24;
}
function _temp() {
  return null;
}
const colors = (type: AlertType): {
  type: AlertType | 'primary';
  main: string;
  light: string;
} => {
  switch (type) {
    case 'error':
      return {
        type: 'error',
        main: 'error.main',
        light: 'error.light'
      };
    case 'success':
      return {
        type: 'success',
        main: 'success.main',
        light: 'success.light'
      };
    case 'warning':
      return {
        type: 'warning',
        main: 'warning.main',
        light: 'warning.light'
      };
    default:
      return {
        type: 'primary',
        main: 'primary.main',
        light: 'primary.light'
      };
  }
};